@use "sass:meta";

.la-decorate-internal-refs__popup {
  position: relative;
  @include meta.load-css("~tippy.js/dist/tippy.css");
  @include meta.load-css("~tippy.js/themes/light-border.css");
  @include meta.load-css("../../styles/tippy");
}

la-akoma-ntoso.flag-internal-refs .akn-ref[href^="#"]::after {
  display: inline-block;
  content: "";
  vertical-align: -.125em;
  background-image: url("data:image/svg+xml,<svg viewBox='0 0 16 16' fill='%239c27b0' xmlns='http://www.w3.org/2000/svg'><path d='M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z'/></svg>");
  background-repeat: no-repeat;
  width: 0.8rem;
  height: 0.8rem;
}
